import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { WordpressReleaseNote } from '@ais-ui/utils';

const fetchReleaseNotes = async () => {
  const response = await fetch(
    'https://gatehousemaritime.com/wp-json/marinepulse/v1/getreleasenotes/'
  );
  if (!response.ok) {
    const errorMessage = `Error: ${response.status} ${response.statusText}`;
    throw new Error(errorMessage);
  }
  return await response.json();
};

export const useReleaseNotes = (
  disabled: boolean
): UseQueryResult<WordpressReleaseNote[], Error> => {
  const onPremise = import.meta.env.VITE_ON_PREMISE === 'true';

  const fetchArticlesConditionally = async () => {
    if (!onPremise) {
      return fetchReleaseNotes();
    } else {
      const response = await fetch('release_notes.json');
      if (!response.ok) {
        throw new Error('Failed to fetch release notes from local JSON');
      }
      return response.json();
    }
  };

  return useQuery({
    queryKey: ['releaseNotes'],
    queryFn: fetchArticlesConditionally,
    enabled: !disabled,
    cacheTime: 0,
  });
};
